import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://icgbunklihjbwsjrfmpy.supabase.co"; // Replace with your Supabase URL
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImljZ2J1bmtsaWhqYndzanJmbXB5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE1ODUzNjksImV4cCI6MjA1NzE2MTM2OX0.KXzXD-xCahON-E6UQQLZwYhS10jRVTDosj_R1EoSwpk"; // Replace with your Supabase Key

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
